'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/secondsFromNow.js
// module id = 738
// module chunks = 0